"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rdf_string_1 = require("rdf-string");

var sparqlee_1 = require("sparqlee");

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A comunica Extend Query Operation Actor.
 *
 * See https://www.w3.org/TR/sparql11-query/#sparqlAlgebra;
 */


var ActorQueryOperationExtend =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationExtend, _bus_query_operation_);

  function ActorQueryOperationExtend(args) {
    _classCallCheck(this, ActorQueryOperationExtend);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationExtend).call(this, args, 'extend'));
  }

  _createClass(ActorQueryOperationExtend, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        var _;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Will throw error for unsupported opperations
                _ = !!new sparqlee_1.AsyncEvaluator(pattern.expression);
                return _context.abrupt("return", true);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(pattern, context) {
        var _this = this;

        var expression, input, variable, output, extendKey, config, evaluator, transform, variables, bindingsStream, metadata;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                expression = pattern.expression, input = pattern.input, variable = pattern.variable;
                _context3.t0 = bus_query_operation_1.ActorQueryOperation;
                _context3.next = 4;
                return this.mediatorQueryOperation.mediate({
                  operation: input,
                  context: context
                });

              case 4:
                _context3.t1 = _context3.sent;
                output = _context3.t0.getSafeBindings.call(_context3.t0, _context3.t1);
                extendKey = rdf_string_1.termToString(variable);
                config = Object.assign({}, bus_query_operation_1.ActorQueryOperation.getExpressionContext(context));
                evaluator = new sparqlee_1.AsyncEvaluator(expression, config); // Transform the stream by extending each Bindings with the expression result

                transform =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(bindings, next) {
                    var result, extended;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return evaluator.evaluate(bindings);

                          case 3:
                            result = _context2.sent;
                            // Extend operation is undefined when the key already exists
                            // We just override it here.
                            extended = bindings.set(extendKey, result);

                            bindingsStream._push(extended);

                            _context2.next = 11;
                            break;

                          case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2["catch"](0);

                            if (sparqlee_1.isExpressionError(_context2.t0)) {
                              // Errors silently don't actually extend according to the spec
                              bindingsStream._push(bindings); // But let's warn anyway


                              _this.logWarn(context, "Expression error for extend operation with bindings '".concat(JSON.stringify(bindings), "'"));
                            } else {
                              bindingsStream.emit('error', _context2.t0);
                            }

                          case 11:
                            next();

                          case 12:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 8]]);
                  }));

                  return function transform(_x5, _x6) {
                    return _ref.apply(this, arguments);
                  };
                }();

                variables = output.variables.concat([extendKey]);
                bindingsStream = output.bindingsStream.transform({
                  transform: transform
                });
                metadata = output.metadata;
                return _context3.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: metadata,
                  variables: variables
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationExtend;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationExtend = ActorQueryOperationExtend;